const prefix = 'COMMON_REPORT';

export const REPORT_FETCHING = `${prefix}_FETCHING`;
export const REPORT_SUCCESS = `${prefix}_SUCCESS`;
export const REPORT_ERROR = `${prefix}_ERROR`;
export const REPORT_CLEAR = `${prefix}_CLEAR`;
export const REPORT_RESET_ERROR = `${prefix}_RESET_ERROR`;



// WEBPACK FOOTER //
// ./src/state/report/types.js